import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface ISupplierFileCabinetFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		supplierId?: any;
		fileCabinetId?: any;
		supplierFileCabinetTypeId?: any;
		expiryDate?: any;
}

export class SupplierFileCabinetFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public supplierId: IEntityModelField = { name: "supplierId", displayName: "Supplier Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public fileCabinetId: IEntityModelField = { name: "fileCabinetId", displayName: "File Cabinet Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public supplierFileCabinetTypeId: IEntityModelField = { name: "supplierFileCabinetTypeId", displayName: "Supplier File Cabinet Type Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public expiryDate: IEntityModelField = { name: "expiryDate", displayName: "Expiry Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.supplierId);
		this.push(this.fileCabinetId);
		this.push(this.supplierFileCabinetTypeId);
		this.push(this.expiryDate);
	}
}

export class SupplierFileCabinetDTO implements IEntityModel {
	protected supplierFileCabinetName: string = "SupplierFileCabinetModel";
	protected supplierFileCabinetKeyField: string = "id";
	protected supplierFileCabinetDisplayName: string = "Supplier File Cabinet|Supplier File Cabinets";
	protected supplierFileCabinetFields = new SupplierFileCabinetFields();
	public get name(): string { return this.supplierFileCabinetName };
	public get keyField(): string { return this.supplierFileCabinetKeyField };
	public get displayName(): string { return this.supplierFileCabinetDisplayName };
	public get fields(): SupplierFileCabinetFields { return this.supplierFileCabinetFields };

	constructor() {};
}
